import _extends from "@babel/runtime/helpers/esm/extends";
let _ = t => t,
  _t;
import * as React from 'react';
import styled from 'styled-components';
import { AI2Mark } from './AI2Mark';
import { AI2MarkText } from './AI2MarkText';
import { color2 } from '../../theme/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dimsBySize = {
  sm: {
    height: 16,
    width: {
      mark: 30,
      gap: 9,
      text: 138
    }
  },
  md: {
    height: 30,
    width: {
      mark: 64,
      text: 189,
      gap: 12
    }
  },
  lg: {
    height: 37,
    width: {
      mark: 79,
      gap: 14,
      text: 233
    }
  }
};
const LogoGrid = styled.span(_t || (_t = _`
  display: inline-grid;
  grid-template-columns: repeat(2, min-content);
  gap: ${0}px;
`), ({
  gap
}) => gap);
/**
 * Component that renders the AI2 Logo.
 */
export function AI2Logo(p) {
  const props = _extends({
    size: 'md',
    color: 'default',
    includeText: true
  }, p);
  const dims = dimsBySize[props.size];
  const [gradients, color] = props.color === 'white' ? [false, color2.N1] : [undefined, undefined];
  if (!props.includeText) {
    return /*#__PURE__*/_jsx(AI2Mark, {
      className: props.className,
      width: dims.width.mark,
      height: dims.height,
      gradients: gradients,
      color: color
    });
  }

  // When the logo is small we resize the viewbox of the text so it's more legible.
  const vw = props.size === 'sm' ? '74 6 190 18' : undefined;
  return /*#__PURE__*/_jsxs(LogoGrid, {
    gap: dims.width.gap,
    className: props.className,
    children: [/*#__PURE__*/_jsx(AI2Mark, {
      width: dims.width.mark,
      height: dims.height,
      gradients: gradients,
      color: color
    }), /*#__PURE__*/_jsx(AI2MarkText, {
      width: dims.width.text,
      height: dims.height,
      color: color,
      viewBox: vw
    })]
  });
}